// import React, { useState, useEffect } from 'react';
// import { Row, Col } from 'antd';
// import { Button, Text, TextField } from '../../components';
// import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
// import { Colors } from '../../config';
// import BasicDrawer from '../../components/Drawer';
// // import PropertyForm from '../../components/DrawerForms/property'
// import AddressForm from '../../components/DrawerForms/address';
// import Document from '../../components/DrawerForms/document';
// import Location from '../../components/DrawerForms/location';
// import Incidenttype from '../../components/DrawerForms/incidenttype';
// import CheckPoint from '../../components/DrawerForms/checkpoint';
// import Geofence from '../../components/DrawerForms/geofence';
// import PhoneNumber from '../../components/DrawerForms/phone';
// import Client from '../../components/DrawerForms/property';
// import CollapseBar from '../../components/Collapse';
// import { SiteManagementAction } from '../../store/actions';
// import { useDispatch, useSelector } from 'react-redux';
// import EmptyData from '../../components/Empty';
// import { Spin } from 'antd';
// import { useParams } from 'react-router-dom';
// import Circular from '../../components/Loader/Circular';
// import RoleCheck from '../../components/RoleCheck/RoleCheck';
// import PageNotFound from '../../components/PageNotFound';
// import useColors from '../../hooks/useColors';

// const Sitemanagementdetail = () => {
//     const { colorPrimary, colorSecondary } = useColors();

//     const dispatch = useDispatch();
//     const { id } = useParams();
//     console.log(id);

//     localStorage.setItem('PropertyKey', id);
//     const propertyDetails = useSelector(
//         (state) => state?.SiteManagementReducer?.propertyDetail,
//     );
//     const loadingState = useSelector(
//         (state) => state?.SiteManagementReducer?.detailLoader,
//     );

//     const user = useSelector((state) => state.AppReducer?.user);
//     const isRole = user?.userRole[0];

//     const [openDrawer, setOpenDrawer] = useState(false);
//     const [formtype, setFormType] = useState('');
//     const [title, setFormTitle] = useState('');
//     const [detailData, setDetailData] = useState({});

//     useEffect(() => {
//         dispatch(SiteManagementAction.GetPropertyDetail(id));
//     }, [id]);

//     const onCloseDrawer = () => {
//         setOpenDrawer(false);
//         setFormType('');
//         setFormTitle('');
//     };

//     const handleInputChange = () => {};

//     const propertyEditDetail = (property) => {
//         setOpenDrawer(true);
//         setFormType('Property');
//         setFormTitle('Edit');
//         setDetailData(property);
//     };

//     const addAddress = () => {
//         setOpenDrawer(true);
//         setFormType('Address');
//         setFormTitle('Add');
//         setDetailData({});
//     };

//     const addressEditDetail = (address) => {
//         setOpenDrawer(true);
//         setFormType('Address');
//         setFormTitle('Edit');
//         setDetailData(address);
//     };

//     const addDocument = () => {
//         setOpenDrawer(true);
//         setFormType('Document');
//         setFormTitle('Add');
//         setDetailData({});
//     };

//     const documentEditDetail = (document) => {
//         setOpenDrawer(true);
//         setFormType('Document');
//         setFormTitle('Edit');
//         setDetailData(document);
//     };

//     const addLocation = () => {
//         setOpenDrawer(true);
//         setFormType('Location');
//         setFormTitle('Add');
//         setDetailData({});
//     };

//     const locationEditDetail = (location) => {
//         setOpenDrawer(true);
//         setFormType('Location');
//         setFormTitle('Edit');
//         setDetailData(location);
//     };

//     // const addIncident = () => {
//     //     setOpenDrawer(true);
//     //     setFormType('Add Incident Types');
//     //     setFormTitle('Add')
//     // }

//     const incidentEditDetail = (incident) => {
//         setOpenDrawer(true);
//         setFormType('Incident Types');
//         setFormTitle('Edit');
//         setDetailData(incident);
//     };

//     const addCheckpoints = () => {
//         setOpenDrawer(true);
//         setFormType('CheckPoints');
//         setFormTitle('Add');
//         setDetailData({});
//     };

//     const checkpointEditDetail = (checkpoint) => {
//         console.log(checkpoint);
//         setOpenDrawer(true);
//         setFormType('CheckPoints');
//         setFormTitle('Edit');
//         setDetailData(checkpoint);
//     };

//     const addGeofence = () => {
//         setOpenDrawer(true);
//         setFormType('Property Geofence');
//         setFormTitle('Add');
//         setDetailData({});
//     };

//     const editGeofenceDetail = (geofence) => {
//         setOpenDrawer(true);
//         setFormType('Property Geofence');
//         setFormTitle('Edit');
//         setDetailData(geofence);
//     };

//     const editPhoneNumber = (contact) => {
//         setOpenDrawer(true);
//         setFormType('Phone Number');
//         setFormTitle('Edit');
//         setDetailData(contact);
//     };

//     return (
//         <>
//             {!loadingState && propertyDetails?.length !== 0 ? (
//                 <>
//                     <Row gutter={[16, 32]} className="mb-10">
//                         <Col span={24}>
//                             <h3 className="text-xl font-bold">
//                                 Site Management
//                             </h3>
//                         </Col>
//                     </Row>

//                     {/* // property Edit Details */}
//                     <Row
//                         gutter={[16, 16]}
//                         className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
//                     >
//                         <Col lg={18} md={18} sm={18} xs={24} className="">
//                             <h3 className="font-semibold text-base">
//                                 Property Details
//                             </h3>
//                         </Col>

//                         <RoleCheck
//                             children={
//                                 <Col
//                                     lg={6}
//                                     md={6}
//                                     sm={6}
//                                     xs={24}
//                                     className="flex justify-end"
//                                 >
//                                     <Button.Basic
//                                         buttonStyle={{
//                                             backgroundColor: colorPrimary,
//                                         }}
//                                         className="w-full px-6 h-10 border-none text-white border-transparent"
//                                         text={'Edit'}
//                                         onClick={() =>
//                                             propertyEditDetail(propertyDetails)
//                                         }
//                                     />
//                                 </Col>
//                             }
//                             task={'Edit'}
//                         />

//                         <Col span={24}>
//                             <hr />
//                         </Col>

//                         <Col span={24} className="rounded-lg">
//                             <Row className="" gutter={[16, 16]}>
//                                 <Col lg={8} md={8} sm={24} xs={24}>
//                                     <Text.Label
//                                         style={{ color: Colors.LabelColor }}
//                                         text={'Location Name'}
//                                     />
//                                     <p className="text-xs">
//                                         {propertyDetails?.name}
//                                     </p>
//                                 </Col>
//                                 <Col lg={9} md={9} sm={24} xs={24}>
//                                     <Text.Label
//                                         style={{ color: Colors.LabelColor }}
//                                         text={'Client'}
//                                     />
//                                     <p className="text-xs">
//                                         {propertyDetails?.company &&
//                                             propertyDetails?.company[0]?.name}
//                                     </p>
//                                 </Col>
//                                 <Col lg={5} md={5} sm={24} xs={24}>
//                                     <Text.Label
//                                         style={{ color: Colors.LabelColor }}
//                                         text={'Property Code'}
//                                     />
//                                     <p className="text-xs">
//                                         {propertyDetails?.code}
//                                     </p>
//                                 </Col>

//                                 <Col lg={24} md={24} sm={24} xs={24}>
//                                     <Text.Label
//                                         style={{ color: Colors.LabelColor }}
//                                         text={'Schedule'}
//                                     />
//                                     <p className="text-xs break-all">
//                                         {propertyDetails?.schedules.length > 0
//                                             ? propertyDetails?.schedules[0]
//                                                   ?.name
//                                             : '-'}
//                                     </p>
//                                 </Col>

//                                 {/* <Col lg={24} md={24} sm={24} xs={24}>
//                                         <Text.Label
//                                             style={{ color: Colors.LabelColor }}
//                                             text={'Property Notes'}
//                                         />
//                                         <p className='text-xs break-all'>{propertyDetails?.note}</p>
//                                     </Col> */}

//                                 <br />
//                             </Row>
//                         </Col>
//                     </Row>

//                     {/* Address Edit Detail */}
//                     <Row
//                         gutter={[16, 16]}
//                         className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
//                     >
//                         <Col lg={18} md={18} sm={18} xs={24} className="">
//                             <h3 className="text-lg font-semibold text-base">
//                                 Address
//                             </h3>
//                         </Col>

//                         <RoleCheck
//                             children={
//                                 <Col
//                                     lg={6}
//                                     md={6}
//                                     sm={6}
//                                     xs={24}
//                                     className="text-end flex justify-end"
//                                 >
//                                     <h3
//                                         style={{ color: Colors.AddMore }}
//                                         onClick={() => addAddress()}
//                                         className="hover:underline cursor-pointer font-semibold text-lg w-fit self-end"
//                                     >
//                                         + Add More
//                                     </h3>
//                                 </Col>
//                             }
//                             task={'Add'}
//                         />

//                         <Col span={24}>
//                             <hr />
//                         </Col>

//                         {propertyDetails &&
//                             propertyDetails?.addresses?.map((item) => {
//                                 return (
//                                     <Col span={24} className="  rounded-lg">
//                                         <Row className="" gutter={[16, 16]}>
//                                             <Col
//                                                 lg={10}
//                                                 md={11}
//                                                 sm={24}
//                                                 xs={24}
//                                             >
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Address'}
//                                                 />
//                                                 <p className="text-xs break-all">{`${item?.streetNumber}, ${item?.streetName}, ${item?.city} ${item?.zip}`}</p>
//                                             </Col>
//                                             <Col lg={4} md={3} sm={24} xs={24}>
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Building Number'}
//                                                 />
//                                                 <p className="text-xs">
//                                                     {item?.buildingNumber}
//                                                 </p>
//                                             </Col>
//                                             <Col lg={3} md={3} sm={24} xs={24}>
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'GPS Longitude'}
//                                                 />
//                                                 <p className="text-xs break-all">
//                                                     {item?.longitude}
//                                                 </p>
//                                             </Col>
//                                             <Col lg={3} md={3} sm={24} xs={24}>
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'GPS Latittude'}
//                                                 />
//                                                 <p className="text-xs break-all">
//                                                     {item?.latitude}
//                                                 </p>
//                                             </Col>

//                                             <RoleCheck
//                                                 children={
//                                                     <Col
//                                                         lg={4}
//                                                         md={4}
//                                                         sm={24}
//                                                         xs={24}
//                                                         className="flex justify-end"
//                                                     >
//                                                         <Button.Basic
//                                                             style={{
//                                                                 backgroundColor:
//                                                                     colorPrimary,
//                                                             }}
//                                                             className="w-full px-6 h-10 border-none text-white border-transparent"
//                                                             text={'Edit'}
//                                                             onClick={() =>
//                                                                 addressEditDetail(
//                                                                     item,
//                                                                 )
//                                                             }
//                                                         />
//                                                     </Col>
//                                                 }
//                                                 task={'Edit'}
//                                             />
//                                         </Row>
//                                         <br />

//                                         <Row
//                                             className="px-2"
//                                             gutter={[16, 16]}
//                                         ></Row>
//                                         <br />
//                                         <Row className="px-2" gutter={16}>
//                                             <Col span={24}>
//                                                 <hr />
//                                             </Col>
//                                         </Row>
//                                     </Col>
//                                 );
//                             })}
//                         {propertyDetails &&
//                         propertyDetails?.addresses?.length == 0 ? (
//                             <Col span={24} className="flex justify-center">
//                                 <EmptyData />
//                             </Col>
//                         ) : (
//                             ''
//                         )}
//                     </Row>

//                     {/* Document Edit Detail */}
//                     <Row
//                         gutter={[16, 16]}
//                         className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
//                     >
//                         <Col lg={18} md={18} sm={18} xs={24} className="">
//                             <h3 className="text-lg font-semibold text-base">
//                                 Documents
//                             </h3>
//                         </Col>

//                         <RoleCheck
//                             children={
//                                 <Col
//                                     lg={6}
//                                     md={6}
//                                     sm={6}
//                                     xs={24}
//                                     className="text-end flex justify-end"
//                                 >
//                                     <h3
//                                         style={{ color: Colors.AddMore }}
//                                         onClick={() => addDocument()}
//                                         className="hover:underline cursor-pointer font-semibold text-lg w-fit self-end"
//                                     >
//                                         + Add More
//                                     </h3>
//                                 </Col>
//                             }
//                             task={'Add'}
//                         />
//                         <Col span={24}>
//                             <hr />
//                         </Col>
//                         {propertyDetails &&
//                             propertyDetails?.documents?.map((item) => {
//                                 return (
//                                     <Col span={24} className="rounded-lg">
//                                         <Row gutter={16} className="">
//                                             <Col
//                                                 lg={8}
//                                                 md={10}
//                                                 sm={24}
//                                                 xs={24}
//                                                 className="mb-2 md:mb-0"
//                                             >
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'File'}
//                                                 />
//                                                 <a
//                                                     href={
//                                                         item.media &&
//                                                         item.media[0]?.url
//                                                     }
//                                                     target="_blank"
//                                                 >
//                                                     <p
//                                                         className="text-xs break-all"
//                                                         style={{
//                                                             color: '#8DB1FD',
//                                                         }}
//                                                     >
//                                                         media
//                                                     </p>
//                                                 </a>
//                                             </Col>
//                                             <Col
//                                                 lg={8}
//                                                 md={6}
//                                                 sm={24}
//                                                 xs={24}
//                                                 className="mb-2 md:mb-0"
//                                             >
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Document Name'}
//                                                 />
//                                                 <p className="text-xs">
//                                                     {item?.name}
//                                                 </p>
//                                             </Col>
//                                             <Col
//                                                 lg={4}
//                                                 md={4}
//                                                 sm={24}
//                                                 xs={24}
//                                                 className="mb-2 md:mb-0"
//                                             >
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Acessibility'}
//                                                 />
//                                                 <p className="text-xs">
//                                                     {item?.accessibility}
//                                                 </p>
//                                             </Col>
//                                             <RoleCheck
//                                                 children={
//                                                     <Col
//                                                         lg={4}
//                                                         md={4}
//                                                         sm={24}
//                                                         xs={24}
//                                                         className="flex justify-end"
//                                                     >
//                                                         <Button.Basic
//                                                             style={{
//                                                                 backgroundColor:
//                                                                     colorPrimary,
//                                                             }}
//                                                             className="w-full px-6 h-1 border-none text-white border-transparent "
//                                                             text={'Edit'}
//                                                             onClick={() =>
//                                                                 documentEditDetail(
//                                                                     item,
//                                                                 )
//                                                             }
//                                                         />
//                                                     </Col>
//                                                 }
//                                                 task={'Edit'}
//                                             />
//                                         </Row>
//                                         <br />
//                                         <Row className="">
//                                             <Col lg={24}>
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Description'}
//                                                 />
//                                                 <p className="text-xs break-all">
//                                                     {item?.description}
//                                                 </p>
//                                             </Col>
//                                         </Row>

//                                         <Row className="px-2 my-4" gutter={16}>
//                                             <Col span={24}>
//                                                 <hr />
//                                             </Col>
//                                         </Row>
//                                     </Col>
//                                 );
//                             })}
//                         <br />

//                         {propertyDetails &&
//                         propertyDetails?.documents?.length == 0 ? (
//                             <Col span={24} className="flex justify-center">
//                                 <EmptyData />
//                             </Col>
//                         ) : (
//                             ''
//                         )}
//                     </Row>

//                     {/* Location Edit Detail */}
//                     <Row
//                         gutter={[16, 16]}
//                         className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
//                     >
//                         <Col lg={18} md={18} sm={18} xs={24} className="">
//                             <h3 className="text-lg font-semibold text-base">
//                                 Locations
//                             </h3>
//                         </Col>
//                         <RoleCheck
//                             children={
//                                 <Col
//                                     lg={6}
//                                     md={6}
//                                     sm={6}
//                                     xs={24}
//                                     className="text-end flex justify-end"
//                                 >
//                                     <h3
//                                         style={{ color: Colors.AddMore }}
//                                         onClick={() => addLocation()}
//                                         className="hover:underline cursor-pointer font-semibold text-lg w-fit self-end"
//                                     >
//                                         + Add More
//                                     </h3>
//                                 </Col>
//                             }
//                             task={'Add'}
//                         />
//                         <Col span={24}>
//                             <hr />
//                         </Col>
//                         {propertyDetails &&
//                             propertyDetails?.locations?.map((item) => {
//                                 return (
//                                     <Col span={24} className="  rounded-lg">
//                                         <Row className="">
//                                             <Col
//                                                 lg={8}
//                                                 md={8}
//                                                 sm={24}
//                                                 xs={24}
//                                                 className="mb-2 md:mb-0"
//                                             >
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Location Name'}
//                                                 />
//                                                 <p className="text-xs">
//                                                     {item?.name}
//                                                 </p>
//                                             </Col>
//                                             <Col
//                                                 lg={12}
//                                                 md={12}
//                                                 sm={24}
//                                                 xs={24}
//                                                 className="mb-2 md:mb-0"
//                                             >
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Assign to'}
//                                                 />
//                                                 <p className="text-xs break-all">
//                                                     {item?.address?.map(
//                                                         (address) => {
//                                                             return (
//                                                                 <>
//                                                                     {`${address?.addressType} - ${address?.streetType} - ${address?.buildingNumber}`}{' '}
//                                                                     <br />
//                                                                 </>
//                                                             );
//                                                         },
//                                                     )}
//                                                 </p>
//                                             </Col>

//                                             <RoleCheck
//                                                 children={
//                                                     <Col
//                                                         lg={4}
//                                                         md={4}
//                                                         sm={24}
//                                                         xs={24}
//                                                         className="flex justify-end"
//                                                     >
//                                                         <Button.Basic
//                                                             // onClick={() => }
//                                                             style={{
//                                                                 backgroundColor:
//                                                                     colorPrimary,
//                                                             }}
//                                                             className="w-full px-6 h-10 border-none text-white border-transparent"
//                                                             text={'Edit'}
//                                                             onClick={() =>
//                                                                 locationEditDetail(
//                                                                     item,
//                                                                 )
//                                                             }
//                                                         />
//                                                     </Col>
//                                                 }
//                                                 task={'Edit'}
//                                             />
//                                         </Row>
//                                         <Row className="my-2">
//                                             <Col
//                                                 lg={24}
//                                                 md={24}
//                                                 sm={24}
//                                                 xs={24}
//                                                 className="mb-2 md:mb-0"
//                                             >
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Description'}
//                                                 />
//                                                 <p className="text-xs break-all">
//                                                     {item?.description}
//                                                 </p>
//                                             </Col>
//                                         </Row>
//                                         <Col span={24} className="mt-4">
//                                             <hr />
//                                         </Col>
//                                         <br />
//                                     </Col>
//                                 );
//                             })}

//                         {propertyDetails &&
//                         propertyDetails?.locations?.length == 0 ? (
//                             <Col span={24} className="flex justify-center">
//                                 <EmptyData />
//                             </Col>
//                         ) : (
//                             ''
//                         )}
//                     </Row>

//                     {/* Incident Edit Detail */}
//                     <Row
//                         gutter={[16, 16]}
//                         className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
//                     >
//                         <Col lg={18} md={18} sm={18} xs={24} className="">
//                             <h3 className="text-lg font-semibold text-base">
//                                 Incident Types
//                             </h3>
//                         </Col>

//                         <RoleCheck
//                             children={
//                                 <Col
//                                     lg={6}
//                                     md={6}
//                                     sm={6}
//                                     xs={24}
//                                     className="flex items-center justify-end"
//                                 >
//                                     <Button.Basic
//                                         style={{
//                                             backgroundColor: colorPrimary,
//                                         }}
//                                         className="h-10 border-none text-white border-transparent px-6"
//                                         text={
//                                             propertyDetails?.incidentTypes
//                                                 ?.length > 0
//                                                 ? 'Edit'
//                                                 : 'Add'
//                                         }
//                                         onClick={() =>
//                                             incidentEditDetail(
//                                                 propertyDetails?.incidentTypes,
//                                             )
//                                         }
//                                     />
//                                 </Col>
//                             }
//                             task={'Edit'}
//                         />

//                         <Col span={24}>
//                             <hr />
//                         </Col>

//                         <Col span={24} className="p-6 rounded-lg ">
//                             <Row className="">
//                                 {propertyDetails &&
//                                     propertyDetails?.incidentTypes?.map(
//                                         (item, i) => {
//                                             return (
//                                                 <>
//                                                     <Col
//                                                         lg={4}
//                                                         md={6}
//                                                         sm={8}
//                                                         xs={24}
//                                                         className="mr-2 mb-2"
//                                                     >
//                                                         <p className="text-xs">{`${i + 1} - ${item?.name}`}</p>
//                                                     </Col>
//                                                 </>
//                                             );
//                                         },
//                                     )}
//                             </Row>
//                         </Col>
//                         {propertyDetails &&
//                         propertyDetails?.incidentTypes?.length == 0 ? (
//                             <Col span={24} className="flex justify-center">
//                                 <EmptyData />
//                             </Col>
//                         ) : (
//                             ''
//                         )}
//                     </Row>

//                     {/* Checkpoints Edit Detail */}
//                     <Row
//                         gutter={[16, 16]}
//                         className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
//                     >
//                         <Col lg={18} md={18} sm={18} xs={24} className="">
//                             <h3 className="text-lg font-semibold text-base">
//                                 Check Points
//                             </h3>
//                         </Col>
//                         <RoleCheck
//                             children={
//                                 <Col
//                                     lg={6}
//                                     md={6}
//                                     sm={6}
//                                     xs={24}
//                                     className="flex items-center justify-end"
//                                 >
//                                     <h3
//                                         style={{ color: Colors.AddMore }}
//                                         onClick={() => addCheckpoints()}
//                                         className="hover:underline cursor-pointer font-semibold text-lg w-fit self-end"
//                                     >
//                                         + Add More
//                                     </h3>
//                                 </Col>
//                             }
//                             task={'Add'}
//                         />

//                         <Col span={24}>
//                             <hr />
//                         </Col>

//                         <Col lg={24} className="">
//                             <CollapseBar
//                                 data={propertyDetails?.checkPoints}
//                                 onChange={checkpointEditDetail}
//                             />
//                         </Col>

//                         {propertyDetails &&
//                         propertyDetails?.checkPoints?.length == 0 ? (
//                             <Col span={24} className="flex justify-center">
//                                 <EmptyData />
//                             </Col>
//                         ) : (
//                             ''
//                         )}
//                     </Row>

//                     {/* Geofence Edit Detail */}
//                     <Row
//                         gutter={[16, 16]}
//                         className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
//                     >
//                         <Col lg={18} md={18} sm={18} xs={24} className="">
//                             <h3 className="text-lg font-semibold text-base">
//                                 Property Geofence
//                             </h3>
//                         </Col>
//                         <RoleCheck
//                             children={
//                                 <Col
//                                     lg={6}
//                                     md={6}
//                                     sm={6}
//                                     xs={24}
//                                     className="text-end flex justify-end"
//                                 >
//                                     <h3
//                                         style={{ color: Colors.AddMore }}
//                                         onClick={() => addGeofence()}
//                                         className="hover:underline cursor-pointer font-semibold text-lg w-fit self-end"
//                                     >
//                                         + Add More
//                                     </h3>
//                                 </Col>
//                             }
//                             task={'Add'}
//                         />
//                         <Col span={24}>
//                             <hr />
//                         </Col>

//                         {propertyDetails &&
//                             propertyDetails?.geofences?.map((item) => {
//                                 return (
//                                     <Col
//                                         span={24}
//                                         className="rounded-lg gry-bg p-4"
//                                     >
//                                         <Row className="px-2">
//                                             <Col
//                                                 lg={8}
//                                                 md={8}
//                                                 sm={8}
//                                                 xs={24}
//                                                 className="mb-2 md:mb-0"
//                                             >
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Geofence Name'}
//                                                 />
//                                                 <p className="text-xs break-all">
//                                                     {item?.name}
//                                                 </p>
//                                             </Col>
//                                             <Col
//                                                 lg={4}
//                                                 md={4}
//                                                 sm={8}
//                                                 xs={24}
//                                                 className="mb-2 md:mb-0"
//                                             >
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Longitude'}
//                                                 />
//                                                 <p className="text-xs">
//                                                     {item?.longitude}
//                                                 </p>
//                                             </Col>
//                                             <Col
//                                                 lg={4}
//                                                 md={4}
//                                                 sm={8}
//                                                 xs={24}
//                                                 className="mb-2 md:mb-0"
//                                             >
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Longitude'}
//                                                 />
//                                                 <p className="text-xs">
//                                                     {item?.latitude}
//                                                 </p>
//                                             </Col>
//                                             {/* <Col lg={4} md={4} sm={8} xs={24} className='mb-2 md:mb-0'>
//                                             <Text.Label
//                                                 style={{ color: Colors.LabelColor }}
//                                                 text={'Radius'}
//                                             />
//                                             <p className='text-xs'>{'-'}</p>
//                                         </Col> */}
//                                             {/* <IoIosArrowForward /> */}

//                                             <RoleCheck
//                                                 children={
//                                                     <Col
//                                                         lg={8}
//                                                         md={8}
//                                                         sm={24}
//                                                         xs={24}
//                                                         className="flex justify-end"
//                                                     >
//                                                         <Button.Basic
//                                                             // onClick={() => }
//                                                             style={{
//                                                                 backgroundColor:
//                                                                     colorPrimary,
//                                                             }}
//                                                             className="w-full px-6 h-10 border-none text-white border-transparent"
//                                                             text={'Edit'}
//                                                             onClick={() =>
//                                                                 editGeofenceDetail(
//                                                                     item,
//                                                                 )
//                                                             }
//                                                         />
//                                                     </Col>
//                                                 }
//                                                 task={'Edit'}
//                                             />
//                                         </Row>
//                                     </Col>
//                                 );
//                             })}

//                         {propertyDetails &&
//                         propertyDetails?.geofences?.length == 0 ? (
//                             <Col span={24} className="flex justify-center">
//                                 <EmptyData />
//                             </Col>
//                         ) : (
//                             ''
//                         )}
//                     </Row>

//                     {/* Contact Edit Detail */}
//                     <Row
//                         gutter={[16, 16]}
//                         className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
//                     >
//                         <Col lg={18} md={18} sm={18} xs={24} className="">
//                             <h3 className="text-lg font-semibold text-base">
//                                 Phone Number
//                             </h3>
//                         </Col>

//                         <RoleCheck
//                             children={
//                                 <Col
//                                     lg={6}
//                                     md={6}
//                                     sm={6}
//                                     xs={24}
//                                     className="text-end flex justify-end"
//                                 >
//                                     <Button.Basic
//                                         // onClick={() => }
//                                         className="w-full px-6 h-10 border-none text-white border-transparent w-fit self-end"
//                                         style={{
//                                             backgroundColor: colorPrimary,
//                                         }}
//                                         s
//                                         text={
//                                             propertyDetails?.contacts?.length >
//                                             0
//                                                 ? 'Edit'
//                                                 : 'Add'
//                                         }
//                                         onClick={() =>
//                                             editPhoneNumber(
//                                                 propertyDetails?.contacts,
//                                             )
//                                         }
//                                     />
//                                 </Col>
//                             }
//                             task={'Edit'}
//                         />

//                         <Col span={24}>
//                             <hr />
//                         </Col>

//                         <Col span={24} className="rounded-lg pb-2">
//                             <Row className="w-full">
//                                 {propertyDetails &&
//                                     propertyDetails?.contacts?.map((item) => {
//                                         return (
//                                             <Col
//                                                 lg={6}
//                                                 md={6}
//                                                 sm={12}
//                                                 xs={24}
//                                                 className="mr-2 mb-2"
//                                             >
//                                                 <Text.Label
//                                                     style={{
//                                                         color: Colors.LabelColor,
//                                                     }}
//                                                     text={'Phone Number'}
//                                                 />
//                                                 <p className="text-xs break-all">
//                                                     {item.number} -{' '}
//                                                     {`(${item?.type})`}
//                                                 </p>
//                                             </Col>
//                                         );
//                                     })}
//                             </Row>
//                         </Col>

//                         {propertyDetails &&
//                         propertyDetails?.contacts?.length == 0 ? (
//                             <Col span={24} className="flex justify-center">
//                                 <EmptyData />
//                             </Col>
//                         ) : (
//                             ''
//                         )}
//                     </Row>

//                     <BasicDrawer
//                         openDrawer={openDrawer}
//                         title={
//                             title == 'Add'
//                                 ? `Add ${formtype}`
//                                 : `Edit ${formtype}`
//                         }
//                         onClose={() => onCloseDrawer()}
//                         width={'700'}
//                     >
//                         {(() => {
//                             switch (formtype) {
//                                 case 'Property':
//                                     return (
//                                         <Client
//                                             clientData={detailData}
//                                             onCloseDrawer={onCloseDrawer}
//                                             isCompanyDetail={true}
//                                         />
//                                     );
//                                 case 'Address':
//                                     return (
//                                         <AddressForm
//                                             addressData={detailData}
//                                             title={title}
//                                             onCloseDrawer={onCloseDrawer}
//                                             isAddressDetail={true}
//                                         />
//                                     );
//                                 case 'Document':
//                                     return (
//                                         <Document
//                                             documentData={detailData}
//                                             title={title}
//                                             onCloseDrawer={onCloseDrawer}
//                                             isDocumentDetail={true}
//                                         />
//                                     );
//                                 case 'Location':
//                                     return (
//                                         <Location
//                                             editLocationData={detailData}
//                                             title={title}
//                                             onCloseDrawer={onCloseDrawer}
//                                             isLocationDetail={true}
//                                         />
//                                     );
//                                 case 'Incident Types':
//                                     return (
//                                         <Incidenttype
//                                             incidentData={detailData}
//                                             onCloseDrawer={onCloseDrawer}
//                                         />
//                                     );
//                                 case 'CheckPoints':
//                                     return (
//                                         <CheckPoint
//                                             checkPointEditData={detailData}
//                                             title={title}
//                                             onCloseDrawer={onCloseDrawer}
//                                             isCheckpointDetail={true}
//                                         />
//                                     );
//                                 case 'Property Geofence':
//                                     return (
//                                         <Geofence
//                                             mapEditData={detailData}
//                                             title={title}
//                                             closeDrawerHandler={onCloseDrawer}
//                                             isGeofenceDetail={true}
//                                         />
//                                     );
//                                 case 'Phone Number':
//                                     return (
//                                         <PhoneNumber
//                                             phoneEditData={detailData}
//                                             closeDrawerHandler={onCloseDrawer}
//                                             isPhoneDetail={true}
//                                         />
//                                     );
//                                 default:
//                                     return null;
//                             }
//                         })()}
//                     </BasicDrawer>
//                 </>
//             ) : !loadingState && propertyDetails?.length == 0 ? (
//                 <PageNotFound desc={'Property Detail Not Found'} />
//             ) : (
//                 <Circular
//                     spinning={loadingState}
//                     size={40}
//                     color={colorPrimary}
//                     containerStyle={{
//                         width: '100%',
//                         height: '100vh',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                     }}
//                 />
//             )}
//         </>
//     );
// };

// export default Sitemanagementdetail;

import React, { useState, useEffect } from 'react';
import { Row, Col, Space, ColorPicker, Input, Tabs, message as antdMessage } from 'antd';
import { Button, Text, TextField } from '../../components';
import { PlusOutlined, SearchOutlined, PrinterOutlined } from '@ant-design/icons';
import { Colors } from '../../config';
import BasicDrawer from '../../components/Drawer';
// import PropertyForm from '../../components/DrawerForms/property'
import AddressForm from '../../components/DrawerForms/address';
import Document from '../../components/DrawerForms/document';
import Location from '../../components/DrawerForms/location';
import Incidenttype from '../../components/DrawerForms/incidenttype';
import CheckPoint from '../../components/DrawerForms/checkpoint';
import Geofence from '../../components/DrawerForms/geofence';
import Client from '../../components/DrawerForms/property';
import CollapseBar from '../../components/Collapse';
import { SiteManagementAction } from '../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import EmptyData from '../../components/Empty';
import { Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import Circular from '../../components/Loader/Circular';
import RoleCheck from '../../components/RoleCheck/RoleCheck';
import PageNotFound from '../../components/PageNotFound';
import useColors from '../../hooks/useColors';
import { IoArrowBack } from 'react-icons/io5';
import PatrolRouteTab from '../Patrol/PatrolRoute/PatrolRouteTab';
import PropertyNotesTab from '../Patrol/PropertyNotes/PropertyNotesTab';
import PropertyPhoneDirectoryPanel from './PropertyPhoneDirectoryPanel';
import { getQrMeta } from '../../config/services/patrolService';
import ApiCaller from '../../config/api';

const Sitemanagementdetail = () => {
    const { colorPrimary } = useColors();

    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();
    console.log(id);

    localStorage.setItem('PropertyKey', id);
    const propertyDetails = useSelector(
        (state) => state?.SiteManagementReducer?.propertyDetail,
    );
    const loadingState = useSelector(
        (state) => state?.SiteManagementReducer?.detailLoader,
    );

    const user = useSelector((state) => state.AppReducer?.user);
    const isRole = user?.userRole[0];

    const [openDrawer, setOpenDrawer] = useState(false);
    const [formtype, setFormType] = useState('');
    const [title, setFormTitle] = useState('');
    const [detailData, setDetailData] = useState({});
    const [isCheckPointUpdated, setIsCheckPointUpdated] = useState(false);

    useEffect(() => {
        dispatch(SiteManagementAction.GetPropertyDetail(id));
    }, [id]);

    const onCloseDrawer = () => {
        setOpenDrawer(false);
        setFormType('');
        setFormTitle('');
        if (
            formtype == 'CheckPoints' &&
            localStorage.getItem('isCheckpointUpdated')
        ) {
            dispatch(SiteManagementAction.GetPropertyDetail(id));
            setIsCheckPointUpdated(false);
            localStorage.removeItem('checkpointId');
            localStorage.removeItem('isCheckpointUpdated');
        }
    };

    const handleInputChange = () => { };

    const propertyEditDetail = (property) => {
        setOpenDrawer(true);
        setFormType('Property');
        setFormTitle('Edit');
        setDetailData(property);
    };

    const addAddress = () => {
        setOpenDrawer(true);
        setFormType('Address');
        setFormTitle('Add');
        setDetailData({});
    };

    const addressEditDetail = (address) => {
        setOpenDrawer(true);
        setFormType('Address');
        setFormTitle('Edit');
        setDetailData(address);
    };

    const addDocument = () => {
        setOpenDrawer(true);
        setFormType('Document');
        setFormTitle('Add');
        setDetailData({});
    };

    const documentEditDetail = (document) => {
        setOpenDrawer(true);
        setFormType('Document');
        setFormTitle('Edit');
        setDetailData(document);
    };

    const addLocation = () => {
        setOpenDrawer(true);
        setFormType('Location');
        setFormTitle('Add');
        setDetailData({});
    };

    const locationEditDetail = (location) => {
        setOpenDrawer(true);
        setFormType('Location');
        setFormTitle('Edit');
        setDetailData(location);
    };

    // const addIncident = () => {
    //     setOpenDrawer(true);
    //     setFormType('Add Incident Types');
    //     setFormTitle('Add')
    // }

    const incidentEditDetail = (incident) => {
        setOpenDrawer(true);
        setFormType('Incident Types');
        setFormTitle('Edit');
        setDetailData(incident);
    };

    const addCheckpoints = () => {
        setOpenDrawer(true);
        setFormType('CheckPoints');
        setFormTitle('Add');
        setDetailData({});
    };

    const checkpointEditDetail = (checkpoint) => {
        console.log(checkpoint);
        setOpenDrawer(true);
        setFormType('CheckPoints');
        setFormTitle('Edit');
        setDetailData(checkpoint);
    };

    const addGeofence = () => {
        setOpenDrawer(true);
        setFormType('Property Geofence');
        setFormTitle('Add');
        setDetailData({});
    };

    const editGeofenceDetail = (geofence) => {
        setOpenDrawer(true);
        setFormType('Property Geofence');
        setFormTitle('Edit');
        setDetailData(geofence);
    };

    // Derived checkpoints for PatrolRouteTab
    const checkpoints = propertyDetails?.checkPoints ?? [];

    const [printingAllQr, setPrintingAllQr] = useState(false);

    const printAllCheckpointQrCodes = async () => {
        const checkpointList = propertyDetails?.checkPoints;
        if (!checkpointList || checkpointList.length === 0) {
            antdMessage.warning('No checkpoints available to print.');
            return;
        }
        setPrintingAllQr(true);
        const objectUrls = [];
        try {
            // Fetch all QR codes in parallel
            const results = await Promise.all(
                checkpointList.map(async (cp) => {
                    try {
                        const meta = await getQrMeta(cp?.id);
                        if (!meta?.pngUrl) return null;
                        const res = await ApiCaller.GetBlob(meta.pngUrl);
                        const blobUrl = URL.createObjectURL(res.data);
                        objectUrls.push(blobUrl);
                        return { name: cp?.name, location: cp?.location, url: blobUrl };
                    } catch {
                        return null;
                    }
                }),
            );
            const valid = results.filter(Boolean);
            if (valid.length === 0) {
                antdMessage.error('Could not load any QR codes.');
                return;
            }
            // Build print HTML: each QR code in a card with its name + location
            const cards = valid
                .map(
                    (cp) => `
                    <div class="qr-card">
                        <img src="${cp.url}" alt="QR" />
                        <div class="qr-label">
                            <strong>${cp.name || ''}</strong>
                            ${cp.location ? `<span>${cp.location}</span>` : ''}
                        </div>
                    </div>`,
                )
                .join('');
            const html = `<!DOCTYPE html><html><head><title>Print All Checkpoint QR Codes</title>
<style>
  body { margin: 0; padding: 16px; font-family: sans-serif; }
  .grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
  .qr-card { display: flex; flex-direction: column; align-items: center; border: 1px solid #eee; border-radius: 8px; padding: 4px; }
  .qr-card img { width: 180px; height: 180px; object-fit: contain; }
  .qr-label { margin-top: 8px; text-align: center; font-size: 12px; display: flex; flex-direction: column; gap: 2px; }
  @media print { .grid { grid-template-columns: repeat(3, 1fr); } }
</style></head><body><div class="grid">${cards}</div></body></html>`;
            const iframe = document.createElement('iframe');
            Object.assign(iframe.style, { position: 'fixed', right: '0', bottom: '0', width: '0', height: '0', border: '0' });
            iframe.onload = () => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            };
            iframe.srcdoc = html;
            document.body.appendChild(iframe);
            window.addEventListener(
                'focus',
                function cleanup() {
                    iframe.remove();
                    // Revoke object URLs after printing
                    objectUrls.forEach((u) => URL.revokeObjectURL(u));
                    window.removeEventListener('focus', cleanup);
                },
                { once: true },
            );
        } catch (err) {
            antdMessage.error('Failed to print QR codes.');
        } finally {
            setPrintingAllQr(false);
        }
    };

    return (
        <>
            {!loadingState && propertyDetails?.length !== 0 ? (
                <>
                    <Row gutter={[16, 32]} className="mb-10">
                        <Col
                            span={24}
                            className="flex items-center justify-between"
                        >
                            <h3 className="text-xl font-bold">
                                Site Management
                            </h3>
                            <div className="flex items-center gap-1 cursor-pointer"
                                    onClick={() => navigate('/site-management')}>
                                <IoArrowBack
                                    size={19}
                                    
                                />
                                back
                            </div>
                        </Col>
                    </Row>

                    {/* // property Edit Details */}
                    <Row
                        gutter={[16, 16]}
                        className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
                    >
                        <Col lg={18} md={18} sm={18} xs={24} className="">
                            <h3 className="font-semibold text-base">
                                Property Details
                            </h3>
                        </Col>

                        <RoleCheck
                            children={
                                <Col
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    xs={24}
                                    className="flex justify-end"
                                >
                                    <Button.Basic
                                        buttonStyle={{
                                            backgroundColor: colorPrimary,
                                        }}
                                        className="w-full px-6 h-10 border-none text-white border-transparent"
                                        text={'Edit'}
                                        onClick={() =>
                                            propertyEditDetail(propertyDetails)
                                        }
                                    />
                                </Col>
                            }
                            task={'Edit'}
                        />

                        <Col span={24}>
                            <hr />
                        </Col>

                        <Col span={24} className="rounded-lg">
                            <Row className="" gutter={[16, 16]}>
                                <Col lg={8} md={8} sm={24} xs={24}>
                                    <Text.Label
                                        style={{ color: Colors.LabelColor }}
                                        text={'Location Name'}
                                    />
                                    <p className="text-xs">
                                        {propertyDetails?.name}
                                    </p>
                                </Col>
                                <Col lg={9} md={9} sm={24} xs={24}>
                                    <Text.Label
                                        style={{ color: Colors.LabelColor }}
                                        text={'Client'}
                                    />
                                    <p className="text-xs">
                                        {propertyDetails?.company &&
                                            propertyDetails?.company[0]?.name}
                                    </p>
                                </Col>
                                <Col lg={5} md={5} sm={24} xs={24}>
                                    <Text.Label
                                        style={{ color: Colors.LabelColor }}
                                        text={'Property Code'}
                                    />
                                    <p className="text-xs">
                                        {propertyDetails?.code}
                                    </p>
                                </Col>

                                <Col lg={8} md={8} sm={24} xs={24}>
                                    <Text.Label
                                        style={{ color: Colors.LabelColor }}
                                        text={'Schedule'}
                                    />
                                    <p className="text-xs break-all">
                                        {propertyDetails?.schedules.length > 0
                                            ? propertyDetails?.schedules[0]
                                                ?.name
                                            : '-'}
                                    </p>
                                </Col>
                                <Col lg={5} md={5} sm={24} xs={24}>
                                    <Text.Label
                                        style={{ color: Colors.LabelColor }}
                                        text={'Property Colour'}
                                    />
                                    <p className="text-xs">
                                        <Space
                                            direction="vertical"
                                            className="w-full flex flex-row items-center"
                                            defaultValue={
                                                propertyDetails?.color
                                            }
                                        >
                                            {/* Color Picker */}
                                            <ColorPicker
                                                value={propertyDetails?.color}
                                            // onChange={(
                                            //     color,
                                            // ) => {
                                            //     // Extract the hex value and send it to the form state
                                            //     const hexColor = color.toHexString(); // This will give you the hex string (e.g., "#ff5733")
                                            //     field.onChange(
                                            //         hexColor,
                                            //     ); // Pass only the hex value to the form state

                                            // }}
                                            />

                                            {/* Display the selected hex code */}

                                            <Input
                                                value={propertyDetails?.color} // Show the hex code in the input
                                                readOnly
                                            />
                                        </Space>
                                    </p>
                                </Col>

                                {/* <Col lg={24} md={24} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Property Notes'}
                                        />
                                        <p className='text-xs break-all'>{propertyDetails?.note}</p>
                                    </Col> */}

                                <br />
                            </Row>
                        </Col>
                    </Row>

                    {/* Address Edit Detail */}
                    <Row
                        gutter={[16, 16]}
                        className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
                    >
                        <Col lg={18} md={18} sm={18} xs={24} className="">
                            <h3 className="text-lg font-semibold text-base">
                                Address
                            </h3>
                        </Col>

                        <RoleCheck
                            children={
                                <Col
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    xs={24}
                                    className="text-end flex justify-end"
                                >
                                    <h3
                                        style={{ color: Colors.AddMore }}
                                        onClick={() => addAddress()}
                                        className="hover:underline cursor-pointer font-semibold text-lg w-fit self-end"
                                    >
                                        + Add More
                                    </h3>
                                </Col>
                            }
                            task={'Add'}
                        />

                        <Col span={24}>
                            <hr />
                        </Col>

                        {propertyDetails &&
                            propertyDetails?.addresses?.map((item) => {
                                return (
                                    <Col span={24} className="  rounded-lg">
                                        <Row className="" gutter={[16, 16]}>
                                            <Col
                                                lg={10}
                                                md={11}
                                                sm={24}
                                                xs={24}
                                            >
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'Address'}
                                                />
                                                <p
                                                    className="text-xs truncate break-all line-clamp-2"
                                                    title={`${item?.streetNumber}, ${item?.streetName}, ${item?.city} ${item?.zip}`}
                                                >{`${item?.streetNumber}, ${item?.streetName}, ${item?.city} ${item?.zip}`}</p>
                                            </Col>
                                            <Col lg={4} md={3} sm={24} xs={24}>
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'Building Number'}
                                                />
                                                <p className="text-xs truncate" title={item?.buildingNumber}>
                                                    {item?.buildingNumber}
                                                </p>
                                            </Col>
                                            <Col lg={3} md={3} sm={24} xs={24}>
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'GPS Longitude'}
                                                />
                                                <p className="text-xs break-all">
                                                    {item?.longitude}
                                                </p>
                                            </Col>
                                            <Col lg={3} md={3} sm={24} xs={24}>
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'GPS Latittude'}
                                                />
                                                <p className="text-xs break-all">
                                                    {item?.latitude}
                                                </p>
                                            </Col>

                                            <RoleCheck
                                                children={
                                                    <Col
                                                        lg={4}
                                                        md={4}
                                                        sm={24}
                                                        xs={24}
                                                        className="flex justify-end"
                                                    >
                                                        <Button.Basic
                                                            style={{
                                                                backgroundColor:
                                                                    colorPrimary,
                                                            }}
                                                            className="w-full px-6 h-10 border-none text-white border-transparent"
                                                            text={'Edit'}
                                                            onClick={() =>
                                                                addressEditDetail(
                                                                    item,
                                                                )
                                                            }
                                                        />
                                                    </Col>
                                                }
                                                task={'Edit'}
                                            />
                                        </Row>
                                        <br />

                                        <Row
                                            className="px-2"
                                            gutter={[16, 16]}
                                        ></Row>
                                        <br />
                                        <Row className="px-2" gutter={16}>
                                            <Col span={24}>
                                                <hr />
                                            </Col>
                                        </Row>
                                    </Col>
                                );
                            })}
                        {propertyDetails &&
                            propertyDetails?.addresses?.length == 0 ? (
                            <Col span={24} className="flex justify-center">
                                <EmptyData />
                            </Col>
                        ) : (
                            ''
                        )}
                    </Row>

                    {/* Document Edit Detail */}
                    <Row
                        gutter={[16, 16]}
                        className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
                    >
                        <Col lg={18} md={18} sm={18} xs={24} className="">
                            <h3 className="text-lg font-semibold text-base">
                                Documents
                            </h3>
                        </Col>

                        <RoleCheck
                            children={
                                <Col
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    xs={24}
                                    className="text-end flex justify-end"
                                >
                                    <h3
                                        style={{ color: Colors.AddMore }}
                                        onClick={() => addDocument()}
                                        className="hover:underline cursor-pointer font-semibold text-lg w-fit self-end"
                                    >
                                        + Add More
                                    </h3>
                                </Col>
                            }
                            task={'Add'}
                        />
                        <Col span={24}>
                            <hr />
                        </Col>
                        {propertyDetails &&
                            propertyDetails?.documents?.map((item) => {
                                return (
                                    <Col span={24} className="rounded-lg">
                                        <Row gutter={16} className="">
                                            <Col
                                                lg={8}
                                                md={10}
                                                sm={24}
                                                xs={24}
                                                className="mb-2 md:mb-0"
                                            >
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'File'}
                                                />
                                                <a
                                                    href={
                                                        item.media &&
                                                        item.media[0]?.url
                                                    }
                                                    target="_blank"
                                                >
                                                    <p
                                                        className="text-xs break-all"
                                                        style={{
                                                            color: '#8DB1FD',
                                                        }}
                                                    >
                                                        media
                                                    </p>
                                                </a>
                                            </Col>
                                            <Col
                                                lg={8}
                                                md={6}
                                                sm={24}
                                                xs={24}
                                                className="mb-2 md:mb-0"
                                            >
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'Document Name'}
                                                />
                                                <p className="text-xs">
                                                    {item?.name}
                                                </p>
                                            </Col>
                                            <Col
                                                lg={4}
                                                md={4}
                                                sm={24}
                                                xs={24}
                                                className="mb-2 md:mb-0"
                                            >
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'Acessibility'}
                                                />
                                                <p className="text-xs">
                                                    {item?.accessibility}
                                                </p>
                                            </Col>
                                            <RoleCheck
                                                children={
                                                    <Col
                                                        lg={4}
                                                        md={4}
                                                        sm={24}
                                                        xs={24}
                                                        className="flex justify-end"
                                                    >
                                                        <Button.Basic
                                                            style={{
                                                                backgroundColor:
                                                                    colorPrimary,
                                                            }}
                                                            className="w-full px-6 border-none text-white border-transparent "
                                                            text={'Edit'}
                                                            onClick={() =>
                                                                documentEditDetail(
                                                                    item,
                                                                )
                                                            }
                                                        />
                                                    </Col>
                                                }
                                                task={'Edit'}
                                            />
                                        </Row>
                                        <br />
                                        <Row className="">
                                            <Col lg={24}>
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'Description'}
                                                />
                                                <p className="text-xs break-all">
                                                    {item?.description}
                                                </p>
                                            </Col>
                                        </Row>

                                        <Row className="px-2 my-4" gutter={16}>
                                            <Col span={24}>
                                                <hr />
                                            </Col>
                                        </Row>
                                    </Col>
                                );
                            })}
                        <br />

                        {propertyDetails &&
                            propertyDetails?.documents?.length == 0 ? (
                            <Col span={24} className="flex justify-center">
                                <EmptyData />
                            </Col>
                        ) : (
                            ''
                        )}
                    </Row>

                    {/* Location Edit Detail */}
                    <Row
                        gutter={[16, 16]}
                        className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
                    >
                        <Col lg={18} md={18} sm={18} xs={24} className="">
                            <h3 className="text-lg font-semibold text-base">
                                Locations
                            </h3>
                        </Col>
                        <RoleCheck
                            children={
                                <Col
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    xs={24}
                                    className="text-end flex justify-end"
                                >
                                    <h3
                                        style={{ color: Colors.AddMore }}
                                        onClick={() => addLocation()}
                                        className="hover:underline cursor-pointer font-semibold text-lg w-fit self-end"
                                    >
                                        + Add More
                                    </h3>
                                </Col>
                            }
                            task={'Add'}
                        />
                        <Col span={24}>
                            <hr />
                        </Col>
                        {propertyDetails &&
                            propertyDetails?.locations?.map((item) => {
                                return (
                                    <Col span={24} className="  rounded-lg">
                                        <Row className="">
                                            <Col
                                                lg={8}
                                                md={8}
                                                sm={24}
                                                xs={24}
                                                className="mb-2 md:mb-0"
                                            >
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'Location Name'}
                                                />
                                                <p className="text-xs">
                                                    {item?.name}
                                                </p>
                                            </Col>
                                            <Col
                                                lg={12}
                                                md={12}
                                                sm={24}
                                                xs={24}
                                                className="mb-2 md:mb-0"
                                            >
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'Building/Address'}
                                                />
                                                <p className="text-xs break-all">
                                                    {item?.address?.map(
                                                        (address) => {
                                                            return (
                                                                <>
                                                                    {`${address?.streetNumber} - ${address?.streetName} - ${address?.city} ${address?.zip}`}{' '}
                                                                    <br />
                                                                </>
                                                            );
                                                        },
                                                    )}
                                                </p>
                                            </Col>

                                            <RoleCheck
                                                children={
                                                    <Col
                                                        lg={4}
                                                        md={4}
                                                        sm={24}
                                                        xs={24}
                                                        className="flex justify-end"
                                                    >
                                                        <Button.Basic
                                                            // onClick={() => }
                                                            style={{
                                                                backgroundColor:
                                                                    colorPrimary,
                                                            }}
                                                            className="w-full px-6 h-10 border-none text-white border-transparent"
                                                            text={'Edit'}
                                                            onClick={() =>
                                                                locationEditDetail(
                                                                    item,
                                                                )
                                                            }
                                                        />
                                                    </Col>
                                                }
                                                task={'Edit'}
                                            />
                                        </Row>
                                        <Row className="my-2">
                                            <Col
                                                lg={24}
                                                md={24}
                                                sm={24}
                                                xs={24}
                                                className="mb-2 md:mb-0"
                                            >
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'Description'}
                                                />
                                                <p className="text-xs break-all">
                                                    {item?.description}
                                                </p>
                                            </Col>
                                        </Row>
                                        <Col span={24} className="mt-4">
                                            <hr />
                                        </Col>
                                        <br />
                                    </Col>
                                );
                            })}

                        {propertyDetails &&
                            propertyDetails?.locations?.length == 0 ? (
                            <Col span={24} className="flex justify-center">
                                <EmptyData />
                            </Col>
                        ) : (
                            ''
                        )}
                    </Row>

                    {/* Incident Edit Detail */}
                    <Row
                        gutter={[16, 16]}
                        className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
                    >
                        <Col lg={18} md={18} sm={18} xs={24} className="">
                            <h3 className="text-lg font-semibold text-base">
                                Incident Types
                            </h3>
                        </Col>

                        <RoleCheck
                            children={
                                <Col
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    xs={24}
                                    className="flex items-center justify-end"
                                >
                                    <Button.Basic
                                        style={{
                                            backgroundColor: colorPrimary,
                                        }}
                                        className="h-10 px-6 border-none text-white border-transparent px-6"
                                        text={
                                            propertyDetails?.incidentTypes
                                                ?.length > 0
                                                ? 'Edit'
                                                : 'Add'
                                        }
                                        onClick={() =>
                                            incidentEditDetail(
                                                propertyDetails?.incidentTypes,
                                            )
                                        }
                                    />
                                </Col>
                            }
                            task={'Edit'}
                        />

                        <Col span={24}>
                            <hr />
                        </Col>

                        <Col span={24} className="p-6 rounded-lg ">
                            <Row className="">
                                {propertyDetails &&
                                    propertyDetails?.incidentTypes?.map(
                                        (item, i) => {
                                            return (
                                                <>
                                                    <Col
                                                        lg={4}
                                                        md={6}
                                                        sm={8}
                                                        xs={24}
                                                        className="mr-2 mb-2"
                                                    >
                                                        <p className="text-xs">{`${i + 1} - ${item?.name}`}</p>
                                                    </Col>
                                                </>
                                            );
                                        },
                                    )}
                            </Row>
                        </Col>
                        {propertyDetails &&
                            propertyDetails?.incidentTypes?.length == 0 ? (
                            <Col span={24} className="flex justify-center">
                                <EmptyData />
                            </Col>
                        ) : (
                            ''
                        )}
                    </Row>

                    {/* Checkpoints Edit Detail */}
                    <Row
                        gutter={[16, 16]}
                        className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
                    >
                        <Col lg={12} md={12} sm={12} xs={24} className="">
                            <h3 className="text-lg font-semibold text-base">
                                Check Points
                            </h3>
                        </Col>
                        <Col
                            lg={12}
                            md={12}
                            sm={12}
                            xs={24}
                            className="flex items-center justify-end gap-3"
                        >
                            <button
                                onClick={printAllCheckpointQrCodes}
                                disabled={printingAllQr || !propertyDetails?.checkPoints?.length}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    background: colorPrimary,
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: 6,
                                    padding: '6px 14px',
                                    cursor: printingAllQr || !propertyDetails?.checkPoints?.length ? 'not-allowed' : 'pointer',
                                    opacity: printingAllQr || !propertyDetails?.checkPoints?.length ? 0.6 : 1,
                                    fontSize: 13,
                                    fontWeight: 500,
                                    height: 36,
                                }}
                            >
                                {printingAllQr ? (
                                    <Spin size="small" style={{ marginRight: 4 }} />
                                ) : (
                                    <PrinterOutlined style={{ fontSize: 15 }} />
                                )}
                                Print All QR Codes
                            </button>
                            <RoleCheck
                                children={
                                    <h3
                                        style={{ color: Colors.AddMore }}
                                        onClick={() => addCheckpoints()}
                                        className="hover:underline cursor-pointer font-semibold text-lg w-fit self-end"
                                    >
                                        + Add More
                                    </h3>
                                }
                                task={'Add'}
                            />
                        </Col>

                        <Col span={24}>
                            <hr />
                        </Col>

                        <Col lg={24} className="">
                            <CollapseBar
                                data={propertyDetails?.checkPoints}
                                onChange={checkpointEditDetail}
                            />
                        </Col>

                        {propertyDetails &&
                            propertyDetails?.checkPoints?.length == 0 ? (
                            <Col span={24} className="flex justify-center">
                                <EmptyData />
                            </Col>
                        ) : (
                            ''
                        )}
                    </Row>

                    {/* Geofence Edit Detail */}
                    <Row
                        gutter={[16, 16]}
                        className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
                    >
                        <Col lg={18} md={18} sm={18} xs={24} className="">
                            <h3 className="text-lg font-semibold text-base">
                                Property Geofence
                            </h3>
                        </Col>
                        <RoleCheck
                            children={
                                <Col
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    xs={24}
                                    className="text-end flex justify-end"
                                >
                                    <h3
                                        style={{ color: Colors.AddMore }}
                                        onClick={() => addGeofence()}
                                        className="hover:underline cursor-pointer font-semibold text-lg w-fit self-end"
                                    >
                                        + Add More
                                    </h3>
                                </Col>
                            }
                            task={'Add'}
                        />
                        <Col span={24}>
                            <hr />
                        </Col>

                        {propertyDetails &&
                            propertyDetails?.geofences?.map((item) => {
                                return (
                                    <Col
                                        span={24}
                                        className="rounded-lg gry-bg p-4"
                                    >
                                        <Row className="px-2">
                                            <Col
                                                lg={8}
                                                md={8}
                                                sm={8}
                                                xs={24}
                                                className="mb-2 md:mb-0"
                                            >
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'Geofence Name'}
                                                />
                                                <p className="text-xs break-all">
                                                    {item?.name}
                                                </p>
                                            </Col>
                                            <Col
                                                lg={4}
                                                md={4}
                                                sm={8}
                                                xs={24}
                                                className="mb-2 md:mb-0"
                                            >
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'Longitude'}
                                                />
                                                <p className="text-xs">
                                                    {item?.longitude}
                                                </p>
                                            </Col>
                                            <Col
                                                lg={4}
                                                md={4}
                                                sm={8}
                                                xs={24}
                                                className="mb-2 md:mb-0"
                                            >
                                                <Text.Label
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                    text={'Longitude'}
                                                />
                                                <p className="text-xs">
                                                    {item?.latitude}
                                                </p>
                                            </Col>
                                            {/* <Col lg={4} md={4} sm={8} xs={24} className='mb-2 md:mb-0'>
                                            <Text.Label
                                                style={{ color: Colors.LabelColor }}
                                                text={'Radius'}
                                            />
                                            <p className='text-xs'>{'-'}</p>
                                        </Col> */}
                                            {/* <IoIosArrowForward /> */}

                                            <RoleCheck
                                                children={
                                                    <Col
                                                        lg={8}
                                                        md={8}
                                                        sm={24}
                                                        xs={24}
                                                        className="flex justify-end"
                                                    >
                                                        <Button.Basic
                                                            // onClick={() => }
                                                            style={{
                                                                backgroundColor:
                                                                    colorPrimary,
                                                            }}
                                                            className="w-full px-6 h-10 border-none text-white border-transparent"
                                                            text={'Edit'}
                                                            onClick={() =>
                                                                editGeofenceDetail(
                                                                    item,
                                                                )
                                                            }
                                                        />
                                                    </Col>
                                                }
                                                task={'Edit'}
                                            />
                                        </Row>
                                    </Col>
                                );
                            })}

                        {propertyDetails &&
                            propertyDetails?.geofences?.length == 0 ? (
                            <Col span={24} className="flex justify-center">
                                <EmptyData />
                            </Col>
                        ) : (
                            ''
                        )}
                    </Row>

                    {/* Phone Number / Contact Directory */}
                    <Row
                        gutter={[16, 16]}
                        className="mb-6 p-4 mx-2 bg-white rounded-lg"
                    >
                        <Col span={24}>
                            <h3 className="text-lg font-semibold text-base mb-2">
                                Phone Number
                            </h3>
                            <hr />
                        </Col>

                        <Col span={24} className="pt-2">
                            <PropertyPhoneDirectoryPanel propertyId={id} />
                        </Col>
                    </Row>

                    {/* Patrol Route Detail */}
                    <Row
                        gutter={[16, 16]}
                        className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
                    >
                        <Col span={24}>
                            <h3 className="text-lg font-semibold text-base mb-2">
                                Patrol Route
                            </h3>
                            <hr />
                        </Col>

                        <Col span={24} className="mt-2">
                            <PatrolRouteTab
                                propertyId={id}
                                checkpoints={checkpoints}
                            />
                        </Col>
                    </Row>

                    {/* Property Notes Detail */}
                    <Row
                        gutter={[16, 16]}
                        className="mb-6 p-4 mx-2 bg-white rounded-lg flex items-center"
                    >
                        <Col span={24}>
                            <h3 className="text-lg font-semibold text-base mb-2">
                                Property Notes
                            </h3>
                            <hr />
                        </Col>

                        <Col span={24} className="mt-2">
                            <PropertyNotesTab propertyId={id} />
                        </Col>
                    </Row>

                    <BasicDrawer
                        openDrawer={openDrawer}
                        title={
                            title == 'Add'
                                ? `Add ${formtype}`
                                : `Edit ${formtype}`
                        }
                        onClose={() => onCloseDrawer()}
                        width={'700'}
                    >
                        {(() => {
                            switch (formtype) {
                                case 'Property':
                                    return (
                                        <Client
                                            clientData={detailData}
                                            onCloseDrawer={onCloseDrawer}
                                            isCompanyDetail={true}
                                        />
                                    );
                                case 'Address':
                                    return (
                                        <AddressForm
                                            addressData={detailData}
                                            title={title}
                                            onCloseDrawer={onCloseDrawer}
                                            isAddressDetail={true}
                                        />
                                    );
                                case 'Document':
                                    return (
                                        <Document
                                            documentData={detailData}
                                            title={title}
                                            onCloseDrawer={onCloseDrawer}
                                            isDocumentDetail={true}
                                        />
                                    );
                                case 'Location':
                                    return (
                                        <Location
                                            editLocationData={detailData}
                                            title={title}
                                            onCloseDrawer={onCloseDrawer}
                                            isLocationDetail={true}
                                        />
                                    );
                                case 'Incident Types':
                                    return (
                                        <Incidenttype
                                            incidentData={detailData}
                                            onCloseDrawer={onCloseDrawer}
                                        />
                                    );
                                case 'CheckPoints':
                                    return (
                                        <CheckPoint
                                            checkPointEditData={detailData}
                                            title={title}
                                            onCloseDrawer={onCloseDrawer}
                                            isCheckpointDetail={true}
                                        />
                                    );
                                case 'Property Geofence':
                                    return (
                                        <Geofence
                                            mapEditData={detailData}
                                            title={title}
                                            closeDrawerHandler={onCloseDrawer}
                                            isGeofenceDetail={true}
                                        />
                                    );
                                default:
                                    return null;
                            }
                        })()}
                    </BasicDrawer>
                </>
            ) : !loadingState && propertyDetails?.length == 0 ? (
                <PageNotFound desc={'Property Detail Not Found'} />
            ) : (
                <Circular
                    spinning={loadingState}
                    size={40}
                    color={colorPrimary}
                    containerStyle={{
                        width: '100%',
                        height: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                />
            )}
        </>
    );
};

export default Sitemanagementdetail;
